import {
  CheckoutOptimizationWidgetType,
  ShippingOptionRenderTarget,
} from "@redotech/redo-conversion-core-common/checkouts/widget";
import { memo, useContext, useMemo } from "react";
import { CheckoutWidgetsBuilderContext } from "../checkout-widgets-builder-context";
import { DetailsShippingOptionWidgetPreview } from "./details-shipping-option-widget-preview";
import { RenderAfterShippingOptionWidgetPreview } from "./render-after-shipping-option-widget-preview";

export const ShippingOptionContentWidgetPreview = memo(
  function ShippingOptionContentWidgetPreview() {
    const { checkoutWidgets } = useContext(CheckoutWidgetsBuilderContext);

    const widget = useMemo(
      () =>
        checkoutWidgets[CheckoutOptimizationWidgetType.SHIPPING_OPTION_CONTENT],
      [checkoutWidgets],
    );

    if (!widget) {
      return null;
    }

    return widget.target === ShippingOptionRenderTarget.DETAILS_RENDER_AFTER ? (
      <DetailsShippingOptionWidgetPreview widget={widget} />
    ) : (
      <RenderAfterShippingOptionWidgetPreview widget={widget} />
    );
  },
);
